import React from 'react'
import Icon from './'

const Beaker = props => (
  <Icon {...props}>
    <path d="M52.88,52.34,40.41,32.08a3.62,3.62,0,0,1-.59-2V19.34h1.3a1.68,1.68,0,0,0,1.68-1.7A1.72,1.72,0,0,0,41.12,16H22.82a1.67,1.67,0,0,0-1.68,1.69,1.72,1.72,0,0,0,1.68,1.7h1.29V30.06a3.47,3.47,0,0,1-.58,2L11.12,52.34a7.12,7.12,0,0,0-.19,7.18,7,7,0,0,0,6.14,3.66h29.8A6.88,6.88,0,0,0,53,59.52,7,7,0,0,0,52.88,52.34ZM34.52,39.79A17.71,17.71,0,0,0,23.27,39l3.17-5.16a7,7,0,0,0,1-3.79V19.34h9.05V30.06a8,8,0,0,0,1,3.79L42,41.1A19.26,19.26,0,0,1,34.52,39.79Z" />
    <path d="M28.64,9.22a2.49,2.49,0,1,0-2.46-2.49A2.47,2.47,0,0,0,28.64,9.22Z" />
    <ellipse cx="34.52" cy="3.21" rx="2" ry="2.03" />
    <path d="M34.91,13.66a2.88,2.88,0,1,0-2.84-2.88A2.87,2.87,0,0,0,34.91,13.66Z" />
  </Icon>
)

export default Beaker
